import { axiosRequest } from '@/plugins/axios-common'
import { cloneDeep } from 'lodash'
import { handleError } from '@/store/handle-error'

const DEFAULT_TEAM = isGlobal => ({
  admin: null,
  config_admin: {
    canCreateCustomRoles: true,
    canManageUsers: true,
  },
  config: {
    canCreateInternalDockets: false,
    canOverrideOwnershipCheck: false,
    canSeeAllResources: false,
    canSeeInternalDockets: false,
  },
  description: '',
  is_global: isGlobal,
  name: '',
  permitted_resources: [],
  restricted_resources: [],
})

export const TeamState = {
  teams: {
    loading: false,
    team: cloneDeep(DEFAULT_TEAM(false)),
    teams: [],
  },
}
export const TeamActions = {
  createPermissionTeam: async ({ commit, getters }) => {
    const team = getters.getPermissionTeam

    commit('setPermissionTeamsLoading', true)

    return axiosRequest.post('/teams', { team }).
      then(({ data }) => {
        commit('setPermissionTeam', data)
        commit('setPermissionTeamsLoading', false)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setPermissionTeamsLoading', false))
  },

  checkIfPermissionTeamNameExists: async (_, name) => {
    return axiosRequest.get(`/teams/validate_name?name=${name}`).
      then(({ data }) => data).
      catch(handleError)
  },

  resetPermissionsTeamDialog: ({ commit }, isGlobal = false) => {
    commit('setPermissionTeam', cloneDeep(DEFAULT_TEAM(isGlobal)))
  },

  setPermissionTeam: ({ commit }, team) => commit('setPermissionTeam', team),
}

export const TeamGetters = {
  getPermissionTeams: state => state.teams.teams,
  getPermissionTeam: state => state.teams.team,
  getPermissionTeamsLoading: state => state.teams.loading,
}

export const TeamMutations = {
  setPermissionTeams: (state, teams) => (state.teams.teams = teams),
  setPermissionTeam: (state, team) => (state.teams.team = team),
  setPermissionTeamsLoading: (state, loading) => (state.teams.loading = loading),
}
